export const config = {
    QRCODE_HOST: process.env.REACT_APP_QRCODE_HOST,
    ENROLL_HOST: process.env.REACT_APP_ENROLL_HOST,
    EVENT_HOST: process.env.REACT_APP_EVENT_HOST,
    JWT_SECRET: process.env.REACT_APP_JWT_SECRET,
    FRONT_HOST: process.env.REACT_APP_FRONT_HOST,
    EVENT_NAME: process.env.REACT_APP_EVENT_NAME,
    SYSTEM_SETTINGS: process.env.REACT_APP_SYSTEM_SETTINGS,
    DAILY_CAPACITY: process.env.REACT_APP_DAILY_CAPACITY ? parseInt(process.env.REACT_APP_DAILY_CAPACITY) : 25000,
    PAYMENT_LINK: process.env.REACT_APP_STRIPE_PAYMENT_LINK_INOVA,
    PAYMENT_API_HOST: process.env.REACT_APP_PAYMENT_SERVICE_HOST,
    IMPRIMIX_API_HOST: process.env.REACT_APP_IMPRIMIX_TICKET_HOST,
    IMPRIMIX_API_TOKEN: process.env.REACT_APP_IMPRIMIX_BASIC_TOKEN,
    ADMIN_PROFILE_ID: process.env.REACT_APP_ADMIN_PROFILE_ID,
    WILDCARD_USER: process.env.REACT_APP_WILDCARD_USER,
    WILDCARD_PASS: process.env.REACT_APP_WILDCARD_PASS,
    MODE: process.env.REACT_APP_ENVIRONMENT,
    STRIPE_API_KEY: process.env.REACT_APP_STRIPE_API_KEY,
    PAYMENT_SUCCESS_PAGE: process.env.REACT_APP_PAYMENT_SUCCESS_PAGE || "https://demo.fazendomais.net/status",
    TICKET_LIMIT: process.env.REACT_APP_TICKET_LIMIT || 3,
    WILDCARD_USER_2: process.env.REACT_APP_WILDCARD_USER_2,
    WILDCARD_PASS_2: process.env.REACT_APP_WILDCARD_PASS_2,
};
